import Header from './components/Header';
import Hero from './components/Hero';
import SectionMedia from './components/SectionMedia';
import SectionApp from './components/SectionApp';
import SectionAbout from './components/SectionAbout';
import SectionRanking from './components/SectionRanking';
import SectionFeatures from './components/SectionFeatures';
import SectionUpdates from './components/SectionUpdates';
import SectionTopics from './components/SectionTopics';
import SectionCarousel from './components/SectionCarousel';
import SectionContact from './components/SectionContact';
import SectionIndex from './components/SectionIndex';
import SectionCards from './components/SectionCards';
import SectionComments from './components/SectionComments';
import SectionFaq from './components/SectionFaq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionMedia />
        <SectionApp />
        <SectionAbout />
        <SectionRanking />
        <SectionFeatures />
        <SectionUpdates />
        <SectionTopics />
        <SectionCarousel />
        <SectionContact />
        <SectionIndex />
        <SectionCards />
        <SectionComments />
        <SectionFaq />
      </main>
      <Footer />
    </>
  );
}